import { theme as chakraTheme, ThemeOverride } from '@chakra-ui/react';
import { breakpoints, device } from '../shared/device';
import { sizes } from '../shared/sizes';

import staticImages from '../../public/revoo/assets/images';
import icons from '../../public/ds-assets/assets/icons';
import { space } from '../shared/space';

export interface Theme {
  device: any;
  sizes: any;
  space: any;
  breakpoints: any;
  colors: {
    palette: {
      primary: {
        0: string; // black
        10: string;
        20: string;
        30: string;
        40: string;
        50: string; // primary
        60: string;
        70: string;
        80: string;
        90: string; // tertiary
        95: string; // bglogin
        100: string; // white
      };
      secondary: {
        0: string;
        10: string;
        20: string;
        30: string;
        40: string;
        50: string; // secondary
        60: string; // darkGray
        70: string;
        80: string;
        90: string; // gray
        95: string; // graylight
        100: string;
      };
      tertiary: {
        0: string;
        1: string;
      };
      status: {
        draft: string;
        toschedule: string;
        todo: string;
        done: string;
      };
      errors: {
        20: string;
        50: string;
        80: string;
        100: string;
      };
      success: {
        20: string;
        50: string;
        80: string;
      };
      warning: {
        20: string;
        50: string;
        80: string;
      };
      info: {
        20: string;
        50: string;
        80: string;
        100: string;
      };
      pending: {
        20: string;
        50: string;
        80: string;
      };
      feedback: {
        80: string;
      };
      ui: {
        1: {
          50: string;
          90: string;
        };
        2: {
          50: string;
          90: string;
        };
        3: {
          50: string;
          90: string;
        };
        4: {
          50: string;
          90: string;
        };
        5: {
          50: string;
          90: string;
        };
      };
      uiColors: {
        1: string;
        2: string;
        3: string;
        4: string;
        5: string;
        6: string;
        7: string;
      };
      transparent: {
        0: string;
      };
      neutral: {
        10: string;
        20: string;
        30: string;
        40: string;
        50: string;
        60: string;
        70: string;
        80: string;
        90: string;
        95: string;
        100: string;
      };
    };
  };
  fonts: {
    heading?: string;
    body?: string;
    mono?: string;
    content?: string;
    Raleway?: string;
    OpenSans?: string;
  };
  fontSizes: {
    xxs: string;
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    '2xl': string;
    '3xl': string;
    '4xl': string;
    '5xl': string;
    '6xl': string;
  };
  fontWeights: {
    light: number;
    normal: number;
    semiBoldRL: number;
    semiBold: number;
    bold: number;
    extraBold: number;
  };
  shadows: {
    sm: string;
    md: string;
    lg: string;
  };
}

const themeBaseDefinition = {
  // images,
  ...chakraTheme,
  brand: 'revoo',
  zIndices: {
    ...chakraTheme.zIndices,
  },
  icons,
  staticImages,
  // Logo,
  // LogoCompact,
  breakpoints,
  device,
  sizes,
  space,
  // MUI theme
  palette: {
    primary: {
      light: '#E4E6E8',
      main: '#000000', // primary
      dark: '000000',
      contrastText: '#fff',
    },
  },
  colors: {
    ...chakraTheme.colors,
    palette: {
      primary: {
        0: '#000000',
        10: '#000000',
        20: '#000000',
        30: '#000000',
        40: '#000000',
        50: '#000000',
        60: '#5b646b',
        70: '#868f98',
        80: '#b5bac0',
        90: '#e4e6e8',
        95: '#f7f8f8',
        100: '#ffffff',
      },
      secondary: {
        0: '#000000',
        10: '#911414',
        20: '#b01919',
        30: '#cf1d1d',
        40: '#ed2d2e',
        50: '#ff5f5f',
        60: '#ff999a',
        70: '#ffbdbd',
        80: '#fed6d6',
        90: '#fff7f7',
        95: '#fef8f8',
        100: '#ffffff',
      },
      tertiary: {
        0: '#F7F8F8',
        1: '#5B646B',
      },
      stroke: {
        primary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
        secondary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
      },
      icon: {
        primary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
        secondary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
      },
      text: {
        primary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
        secondary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
      },
      surface: {
        primary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
        secondary: {
          0: '#000000',
          10: '#000000',
          20: '#000000',
          30: '#000000',
          40: '#000000',
          50: '#000000',
          60: '#5b646b',
          70: '#868f98',
          80: '#b5bac0',
          90: '#e4e6e8',
          95: '#f7f8f8',
          100: '#ffffff',
        },
      },
      status: {
        draft: '#A7A7A7',
        toschedule: 'red',
        todo: '#0052EE',
        done: '#0052EE',
      },
      transparent: {
        0: '#F7F8F8',
      },
      ui: {
        1: {
          0: '#000000',
          10: '#052727',
          20: '#0b5454',
          30: '#118181',
          40: '#17aeae',
          50: '#1ddbdb',
          60: '#60eaea',
          70: '#84efef',
          80: '#a8f3f3',
          90: '#ccf8f8',
          95: '#f0fdfd',
          100: '#ffffff',
        },
        2: {
          0: '#000000',
          10: '#0f2d0a',
          20: '#1e5b14',
          30: '#2d891f',
          40: '#3cb729',
          50: '#57d543',
          60: '#8be27d',
          70: '#a5e99b',
          80: '#bfefb8',
          90: '#d9f6d5',
          95: '#f3fcf2',
          100: '#ffffff',
        },
        3: {
          0: '#000000',
          10: '#1d0b4f',
          20: '#2f1281',
          30: '#4019b2',
          40: '#5423e0',
          50: '#7a54e7',
          60: '#a48aef',
          70: '#b9a5f2',
          80: '#cdbff6',
          90: '#e2dafa',
          95: '#f7f5fe',
          100: '#ffffff',
        },
        4: {
          0: '#000000',
          10: '#49001a',
          20: '#77002a',
          30: '#a5003a',
          40: '#d3004a',
          50: '#e80051',
          60: '#ff4586',
          70: '#ff73a4',
          80: '#ffa1c2',
          90: '#ffcfdf',
          95: '#ffeff4',
          100: '#ffffff',
        },
        5: {
          0: '#000000',
          10: '#451b00',
          20: '#6e2b00',
          30: '#a13f00',
          40: '#d95500',
          50: '#ff6f12',
          60: '#ff9a59',
          70: '#ffb07d',
          80: '#ffccab',
          90: '#ffdbc4',
          95: '#fbede0',
          100: '#ffffff',
        },
        6: {
          0: '#000000',
          10: '#07153d',
          20: '#0c2266',
          30: '#11308f',
          40: '#163eb8',
          50: '#1b4ce1',
          60: '#6184ec',
          70: '#86a0f0',
          80: '#abbdf5',
          90: '#cfd9f9',
          95: '#f3f6fe',
          100: '#ffffff',
        },
        7: {
          0: '#000000',
          10: '#383605',
          20: '#625e09',
          30: '#8c860d',
          40: '#b6af11',
          50: '#e0d715',
          60: '#efe957',
          70: '#f5ef6e',
          80: '#f6f38e',
          90: '#f8f5b5',
          95: '#fdfded',
          100: '#ffffff',
        },
      },
      neutral: {
        0: '#000000',
        10: '#535c65',
        20: '#65707b',
        30: '#818c98',
        40: '#a8b0b8',
        50: '#c7ccd1',
        60: '#dbdee0',
        70: '#e6e8ea',
        80: '#ebedef',
        90: '#f4f5f6',
        95: '#fbfbfc',
        100: '#ffffff',
      },
      errors: {
        0: '#0e0e0e',
        20: '#890005',
        50: '#bc0007',
        60: '#ff565c',
        80: '#ffd0d2',
      },
      success: {
        0: '#0e0e0e',
        20: '#144f32',
        50: '#1cce7f',
        80: '#c7f6d7',
      },
      warning: {
        0: '#0e0e0e',
        20: '#d57600',
        50: '#faa938',
        80: '#fde5c3',
      },
      info: {
        0: '#0e0e0e',
        20: '#3c206b',
        50: '#8357cd',
        80: '#e0d5f2',
      },
      pending: {
        0: '#0e0e0e',
        10: '#605100',
        20: '#937c00',
        50: '#ffde2d',
        80: '#fff8d0',
        90: '#fffbe3',
      },
      feedback: {
        80: '#E1E4FC',
      },
      form: {
        error: {
          0: '#e53e3e',
        },
      },
    },
  },
  fonts: {
    heading: 'inter',
    body: 'inter',
    mono: 'Menlo, monospace',
  },
  fontSizes: {
    xxs: '0.625rem', // 10px
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    md: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.75rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem', // 48px
    '6xl': '4rem', // 64px
  },
  shadows: {
    sm: '0px 0px 4px rgba(212,212,212, 1)',
    md: '0px 3px 4px rgba(212,212,212, 1)',
    lg: '0px 3px 7px rgba(212,212,212, 1)',
    8: '0px 3px 7px rgba(212,212,212, 1)',
  },
};

/** Token semantici sotto `theme.colors.palette` (evita conflitto con i tipi Chakra su `colors.palette`). */
export type DesignSystemColorPalette = Record<string, any>;

type ChakraThemeColors = NonNullable<Partial<ThemeOverride>['colors']>;

export type AppThemeConfig = Omit<Partial<ThemeOverride>, 'colors'> & {
  colors: Omit<ChakraThemeColors, 'palette'> & {
    palette: DesignSystemColorPalette;
  };
};

export const themeBase = themeBaseDefinition as Partial<ThemeOverride>;

